$(document).ready(function() {
    $('.scroll').click(function(event) {
        event.preventDefault();
        jQuery('html,body').animate({ scrollTop: jQuery(this.hash).offset().top }, 200);
    });

    $('#on-page-nav li')
        .eq(0)
        .addClass('active');
    var navChildren = $('#on-page-nav li').children();
    var aArray = [];
    for (var i = 0; i < navChildren.length; i++) {
        var aChild = navChildren[i];
        var ahref = $(aChild).attr('href');
        aArray.push(ahref);
    }

    $(window).scroll(function() {
        var windowPos = $(window).scrollTop();
        var windowHeight = $(window).height();
        var docHeight = $(document).height();
        for (var i = 0; i < aArray.length; i++) {
            var theID = aArray[i];
            var secPosition = $(theID).offset().top;
            secPosition = secPosition - 300;
            var divHeight = $(theID).height();
            // divHeight = divHeight + 90;
            if (windowPos >= secPosition && windowPos < secPosition + divHeight) {
                $("a[href='" + theID + "']")
                    .parent()
                    .addClass('active');
            } else {
                $("a[href='" + theID + "']")
                    .parent()
                    .removeClass('active');
            }
        }
    });
});

// $(function() {
//     $('a[href*=\\#]:not([href=\\#])').on('click', function() {
//         var target = $(this.hash);
//         target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
//         if (target.length) {
//             $('html,body').animate({
//                 scrollTop: target.offset().top
//             }, 1000);
//             return false;
//         }
//     });
// });
